import React from 'react'
import Gift from 'images/icons/Gift'
import Dropdown from 'atoms/Dropdown'
import { ProfileConsumer } from 'contexts/profile-context'
import { SettingsConsumer } from 'contexts/settings-context'
import { getUrlParameter } from 'tools/url'
import { bonusBalanceForClient, getMostRecentBonus } from 'tools/wallet'
import DropdownBody from './components/DropdownBody'
import MFL10sDropdownBody from './components/MFL10sDropdownBody'

class PromoNotifications extends React.Component {
  state = {
    startOpen: false,
  }

  componentDidMount() {
    const urlParam = getUrlParameter('openPromo')
    const shouldOpenPromo = Boolean(urlParam)

    if (shouldOpenPromo === true) {
      this.setState({ startOpen: true })
    }
  }

  render() {
    return (
      <SettingsConsumer>
        {(settings) => {
          return (
            <ProfileConsumer>
              {(profile) => {
                const hasMFL10sBonus = bonusBalanceForClient('mfl10', profile.bonuses) > 0
                const hasFanballBonus = bonusBalanceForClient('fanball', profile.bonuses) > 0
                const showGiftBox = hasMFL10sBonus || hasFanballBonus

                if (showGiftBox === false) {
                  return null
                }

                const mostRecentBonus = getMostRecentBonus(profile.bonuses)
                const showMFL10sBonus =
                  mostRecentBonus &&
                  mostRecentBonus.applicableClients &&
                  mostRecentBonus.applicableClients.length === 1 &&
                  mostRecentBonus.applicableClients[0] === 'mfl10'

                return (
                  <Dropdown label={<Gift id="shgn-gift-box" />} startOpen={this.state.startOpen}>
                    {showMFL10sBonus ? (
                      <MFL10sDropdownBody bonus={mostRecentBonus} />
                    ) : (
                      <DropdownBody bonus={mostRecentBonus} />
                    )}
                  </Dropdown>
                )
              }}
            </ProfileConsumer>
          )
        }}
      </SettingsConsumer>
    )
  }
}

export default PromoNotifications



// WEBPACK FOOTER //
// ./src/molecules/PromoNotifications/PromoNotifications.js